<template>
    <v-card
        flat
        elevation="0"
        class="bible-form"
        :loading="loading"
    >
        <v-card-title>
            <span class="header2">{{ $t('data_gatherings.replace_form.title') }}</span>
            <span class="header2">&nbsp;|&nbsp;</span>
            <span class="subtitle" style="font-size: 20px !important;">{{ dataGatheringInfo.title }}</span>
        </v-card-title>
        <v-card-text>
            <v-form
                @submit.prevent="submit"
                :disabled="loading"
                v-model="flags.form_valid"
                ref="form"
            >
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <span class="label">{{ $t('data_gatherings.academic_period') }}:</span>
                            <div class="modal-replace-data body-text body-text--dark-gray">
                                {{ dataGatheringInfo.academic_period }}
                            </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <span class="label">{{ $t('data_gatherings.type') }}:</span>

                            <div class="modal-replace-data body-text body-text--dark-gray">
                                {{ dataGatheringInfo.type }}
                            </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <span class="label">{{ $t('data_gatherings.strategy') }}:</span>

                            <div class="modal-replace-data body-text body-text--dark-gray">
                                {{ dataGatheringInfo.strategy }}
                            </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <span class="label">{{ $t('data_gatherings.notes') }}:</span>

                            <div class="modal-replace-data body-text body-text--dark-gray">
                                {{ dataGatheringInfo.notes }}
                            </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <span class="label">{{ $t('data_gatherings.strategy') }}:</span>
                            <v-select
                                class="input-text input-text--select body-text"
                                :disabled="strategies.length < 0"
                                v-model="data_gathering.strategy.id"
                                :rules="data_gathering_rules.data_strategy"
                                dense
                                solo
                                flat
                                outlined
                                :items="strategies"
                                required
                                item-text="title"
                                item-value="id"
                                hide-details="auto"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <span class="label">{{ $t('data_gatherings.mode') }}:</span>
                            <v-select
                                class="input-text input-text--select body-text"
                                :disabled="availableModes.length < 0"
                                v-model="data_gathering.mode"
                                :rules="data_gathering_rules.mode"
                                dense
                                solo
                                flat
                                outlined
                                :items="availableModes"
                                required
                                item-text="title"
                                hide-details="auto"
                            />
                        </v-col>
                        <v-col cols="12" v-if="data_gathering.mode === 'manual'">
                            <span class="label">{{ $t('data_gatherings.import') }}:</span>
                            <br />
                            <div class="upload-container" v-if="!spreadSheetSelected">
                                <drag-and-drop-file-picker
                                    @select="this.uploadFile"
                                />

<!--                                <div class="o-divider">-->
<!--                                    <v-spacer />-->
<!--                                    <div class="o-partition">o</div>-->
<!--                                    <v-spacer />-->
<!--                                </div>-->

<!--                                <google-drive-file-picker-->
<!--                                    :disabled="!this.googleDrive"-->
<!--                                />-->
                            </div>
                            <div class="file-container" v-if="spreadSheetSelected">
                                <v-card v-if="spreadSheetData">
                                    <div class="file-card-icon">
                                        <v-icon class="check align-middle">mdi-file-excel</v-icon>
                                    </div>
                                    <div class="text-cont">
                                        <v-card-title class="body-text">
                                            {{ spreadSheetData.file_name }}
                                        </v-card-title>
                                        <v-card-subtitle class="small-body">
                                            {{ spreadSheetData.size | toHumanSize }}
                                        </v-card-subtitle>
                                    </div>
                                    <v-spacer />
                                    <v-spacer />
                                    <v-spacer />
                                    <v-btn @click="removeSpreadSheet" class="btn-icon btn-icon--delete">
                                        <v-icon>mdi-trash-can</v-icon>
                                    </v-btn>
                                </v-card>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-btn
                class="v-btn--secondary"
                elevation="0"
                :loading="loading"
                @click="this.cancel"
            >
                {{ $t('data_gatherings.cancel') }}
            </v-btn>
            <v-btn
                class="v-btn--primary"
                :loading="loading"
                :disabled="!formValid"
                elevation="0"
                @click="this.submit"
            >
                {{ $t('data_gatherings.replace') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import _ from "lodash";
import StrategySelectionMixin from "@/Shared/DathaGatherings/Common/Forms/StrategySelectionMixin";
import toastMixin from "@/Shared/toastMixin";
import {mapActions} from "pinia";
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";

/**
 * All flags used in this component, this will be used as a factory function
 *
 * @returns {{saving: boolean, form_valid: boolean, spreadSheetSelected: boolean, file_loading: boolean}}
 */
const buildFlags = () => ({
    saving: false,
    file_loading: false,
    form_valid: false,
    spreadSheetSelected: false,
});

export default {
    name: "ReplaceForm",

    mixins: [StrategySelectionMixin, toastMixin],

    props: {
        dataGathering: {
            type: Object,
            require: true,
        },
    },

    data: () => ({
        flags: buildFlags(),
    }),

    methods: {
        submit() {
            if(!this.formValid){
                return;
            }

            this.flags.saving = true;

            //set created by info
            const user = _.get(this.$page.props, 'auth');
            this.data_gathering.setReplacedBy(user);

            return this.replace(this.data_gathering)
                .then(data_gathering => {
                    this.$emit('replace', data_gathering);

                    this.toast().success(
                        this.$t('data_gatherings.replace_form.success_store_title', {data_gathering: data_gathering.title}),
                        this.$t('data_gatherings.replace_form.success_store_message'),
                    );
                })
                .catch(error => {
                    this.toast().error(
                        this.$t('data_gatherings.replace_form.error_store_title'),
                        this.$t('data_gatherings.replace_form.error_store_message'),
                    );

                    console.error('data-gathering.replace.error', error, _.cloneDeep(this.data_gathering));
                })
                .finally(() => this.flags.saving = false);
        },

        cancel() {
            this.clone(this.dataGathering);

            //emmit a local event
            this.$emit('cancel');
        },

        ...mapActions(DataGatheringsStore, [
            'replace'
        ])
    },

    computed: {
        dataGatheringInfo() {
            return {
                title: this.data_gathering.title,
                type: this.data_gathering.type.title,
                academic_period: this.data_gathering.academic_period.title,
                strategy: this.data_gathering.strategy.title,
                notes: this.data_gathering.notes || '-',
            };
        },

        loading() {
            return this.flags.saving || this.flags.file_loading;
        },

        formValid() {
            return this.flags.form_valid && !!this.spreadSheetData.file_name;
        },
    },

    watch: {
        dataGathering: {
            handler() {
                //warn external changes?

                this.clone(this.dataGathering);
            },

            deep: true,
        }
    },

    mounted() {
        this.clone(this.dataGathering);
    },
}
</script>

<style scoped>

</style>
